'use client'

import type { PropsWithChildren } from 'react'
import { DeferredAnalytics } from '@/app/_components/DeferredAnalytics'
import { DeferredTagManager } from '@/app/_components/DeferredTagManager'
import { AppProviders } from '@/app/providers/AppProviders'
import { SiteFooter } from '@/shared/ui/SiteFooter'

export function ClientShell({ children }: PropsWithChildren) {
  return (
    <AppProviders>
      {children}
      <SiteFooter />
      <DeferredTagManager />
      <DeferredAnalytics />
    </AppProviders>
  )
}
